import { tw } from "@sveabank/cc-common";

type Props = {
	isActive: boolean;
	isCompleted?: boolean;
	hasWarning?: boolean;
};

const MobileNavStep = ({ isActive, isCompleted, hasWarning }: Props) => {
	const stepStyling = tw(
		"first:rounded-l-large last:rounded-r-large mx-1 flex h-[10px] w-full grow-0 rounded-sm",
		isCompleted && "bg-interactive-primary",
		!isActive && !isCompleted && "bg-foreground-divider",
		hasWarning && "bg-foreground-alert",
		isActive && "bg-decorative-brand-primary",
	);
	return <div className={stepStyling} />;
};

export default MobileNavStep;
